// Modal de gestion des cookies uniquement (sans bannière ni bouton flottant)
// Les cookies analytics sont exemptés du consentement préalable en France (avec IP anonymisé)
export const createCookieSettingsModal = () => {
  return `
      <div id="cookie-settings-modal" class="fixed inset-0 bg-black/60 backdrop-blur-sm hidden z-50">
          <div class="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-white rounded-2xl p-8 max-w-lg w-full mx-4 shadow-2xl">
              <h3 class="text-2xl font-bold mb-2 text-[#133AC9]" data-translate="cookie.modal.title">Paramètres des cookies</h3>
              <p class="text-gray-600 mb-6" data-translate="cookie.modal.subtitle">Personnalisez vos préférences de confidentialité</p>

              <div class="space-y-6">
                  <div class="flex items-start justify-between p-4 rounded-xl bg-gray-50">
                      <div>
                          <p class="font-medium text-[#133AC9]" data-translate="cookie.modal.necessary.title">Cookies nécessaires</p>
                          <p class="text-sm text-gray-600 mt-1" data-translate="cookie.modal.necessary.desc">Indispensables au fonctionnement du site</p>
                      </div>
                      <div class="relative">
                          <input type="checkbox" checked disabled class="toggle toggle-primary bg-[#133AC9]" />
                      </div>
                  </div>

                  <div class="flex items-start justify-between p-4 rounded-xl bg-gray-50">
                      <div>
                          <p class="font-medium text-[#133AC9]" data-translate="cookie.modal.analytics.title">Cookies analytiques</p>
                          <p class="text-sm text-gray-600 mt-1" data-translate="cookie.modal.analytics.desc">Nous aident à améliorer votre expérience</p>
                      </div>
                      <div class="relative">
                          <input type="checkbox" id="analytics-toggle" checked class="toggle toggle-primary bg-[#133AC9]" />
                      </div>
                  </div>

                  <div class="flex items-start justify-between p-4 rounded-xl bg-gray-50">
                      <div>
                          <p class="font-medium text-[#133AC9]" data-translate="cookie.modal.preferences.title">Cookies de préférences</p>
                          <p class="text-sm text-gray-600 mt-1" data-translate="cookie.modal.preferences.desc">Sauvegardent vos préférences</p>
                      </div>
                      <div class="relative">
                          <input type="checkbox" id="preferences-toggle" class="toggle toggle-primary bg-[#133AC9]" />
                      </div>
                  </div>
              </div>

              <div class="flex justify-end gap-3 mt-8">
                  <button id="cookie-save" class="px-6 py-2.5 bg-[#133AC9] text-white rounded-3xl hover:bg-[#497BF8] transition-all" data-translate="cookie.modal.save">
                      Enregistrer mes préférences
                  </button>
              </div>
          </div>
      </div>
  `;
};

// Ancienne fonction conservée pour compatibilité (deprecated)
export const createCookieConsent = () => {
  return createCookieSettingsModal();
};
